import CheckboxGroup from '@components/checkbox';
import { store, store$ } from '@redux/store';
import { marketingCampaignPreferencesActions } from 'features/marketingCampaign';
import { selectEmail, selectIsLoggedIn } from 'features/userProfile';
import { filter, fromEvent, map, mergeMap, of, partition, take, tap } from 'rxjs';

const inputEmail = document.querySelector('#emailUnsubscribe');
const emailPattern = new RegExp(inputEmail.dataset.pattern);
const submitButton = document.querySelector('[data-btn-unsubscribe]');
const submitButtonClick$ = fromEvent(submitButton, 'click');
const isValidEmail$ = submitButtonClick$.pipe(map(() => emailPattern.test(inputEmail.value)));
const [showUnsubscribeFeedbackForm$, showEmailErrorMessage$] = partition(isValidEmail$, isValid => isValid);
const marketingCampaignPreferences = document.querySelector('[data-marketing-campaign-preferences]');
const checkboxGroup = new CheckboxGroup(marketingCampaignPreferences);
const checkboxGroupChange$ = checkboxGroup.getObservable();
const unsubscribeAllInput = document.querySelector('[data-unsubscribe-all]');
const unsubscribeAllInputChange$ = fromEvent(unsubscribeAllInput, 'change').pipe(map((event) => event.target.checked));
const onUserLogIn$ = store$.pipe(filter(selectIsLoggedIn), map(selectEmail), take(1));
const unsubscribeFeedbackItems = document.querySelector('[data-unsubscribe-feedback-items]');
const feedbackItemsClick$ = fromEvent(unsubscribeFeedbackItems, 'click').pipe(map((event) => event.target));

const feedbackCustomOptionHandler = (target) => {
  const customOptionInput = document.querySelector('#otherFeedback');
  if (target.dataset.category === 'Other') {
    customOptionInput.disabled = false;
    customOptionInput.classList.add('able');
  } else {
    customOptionInput.disabled = true;
    customOptionInput.value = '';
  }
}

const enableSubmitFeedbackButton = () => {
    const unsubscribeFeedbackSubmit = document.querySelector('[data-unsubscribe-feedback-submit]');
    unsubscribeFeedbackSubmit.disabled = false;
}

const updateCheckboxStatus = function(statusValue){
  marketingCampaignPreferences.querySelectorAll('[type="checkbox"]').forEach((checkbox) => {
    checkbox.checked = statusValue;
  });
}

const turnOffUnSubscribeAllInput = () => { 
  const unsubscribeAll = document.querySelector('[data-unsubscribe-all]');
  if (unsubscribeAll) {
    unsubscribeAll.checked = false;
  }
};
  
const showEmailErrorMessage =  () => {
  const errorElement = document.querySelector('[data-unsubscribe-error-message]');
  errorElement.removeAttribute('hidden');
  inputEmail.classList.add('error');
}

/** *
 * Remove the hidden attribute of the span element containing the error text for the input 
 * where the custom feedback comment is added.
 * Also add the error class to add the corresponding styles to an input with error.
 */
const showCommentErrorMessage =  () => {
  const errorElement = document.querySelector('[data-unsubscribe-feedback-error-message]');
  errorElement.removeAttribute('hidden');
  const customOptionInput = document.querySelector('#otherFeedback');
  customOptionInput.classList.add('error');
}

const showThankYouMessage =  () => {
  const thankYouMessage = document.querySelector('[data-unsubscribe-thanks]');
  const unsubscribeFeedbackForm = document.querySelector('[data-unsubscribe-feedback]');

  thankYouMessage.removeAttribute('hidden');
  unsubscribeFeedbackForm.setAttribute('hidden', '');
}

const submitUnsubscribeFeedback = () => {
  const unsubscribeFeedback = document.querySelector('[data-unsubscribe-feedback-items]');
  const customOptionInput = document.querySelector('#otherFeedback');
  const userEmail = sessionStorage.getItem('email');
  const chosenMarketingCampaigns = JSON.parse(sessionStorage.getItem('marketingCampaigns'));

  const reasons = Array.from(
    unsubscribeFeedback.querySelectorAll(':checked'))?.map(option => ({
      category: option.dataset.category,
      text: customOptionInput.value || option.value 
    }));

  const payload = {
    unsubscribeReasons: reasons,
    email: userEmail,
    marketingCampaigns: chosenMarketingCampaigns
  };

  store.dispatch(marketingCampaignPreferencesActions.fetchUnsubscribeFeedback(payload));
}

/** *
 * Checks if the data required to send the unsubscribe feedback is being fulfilled.
 * 1. Any radio buttom is checked
 * 2. If the radio buttom with the "Other" option is checked, it must not have an empty input at the 
 * time of sending it.
 */
const shouldShowThankYouMessage = () => {
  const customOptionInput = document.querySelector('#otherFeedback');
  const currentInput = unsubscribeFeedbackItems.querySelector(':checked');
  const isCustomCategory = currentInput.dataset.category === 'Other' && customOptionInput.value.trim().length > 0;
  
  return isCustomCategory || currentInput.dataset.category !== 'Other';
}

const showUnsubscribeFeedbackForm = () => {
  const unsubscribeFeedbackForm = document.querySelector('[data-unsubscribe-feedback]');
  const formContainer = document.querySelector('[data-unsubscribe-container]');

  unsubscribeFeedbackForm.removeAttribute('hidden');
  formContainer.setAttribute('hidden', '');

  const unsubscribeFeedbackSubmit = document.querySelector('[data-unsubscribe-feedback-submit]');
  const unsubscribeFeedbackSubmitClick$ = fromEvent(unsubscribeFeedbackSubmit, 'click');

  const isValidFeedbackComment$ = unsubscribeFeedbackSubmitClick$.pipe(
    map(shouldShowThankYouMessage)
  );
  const [submitUnsubscribeFeedback$, showCommentErrorMessage$] = partition(isValidFeedbackComment$, isValid => isValid);
  submitUnsubscribeFeedback$.pipe(
    tap(showThankYouMessage)
  ).subscribe(submitUnsubscribeFeedback);
  showCommentErrorMessage$.subscribe(showCommentErrorMessage);

  const unsubscribeFeedbackSkip = document.querySelector('[data-unsubscribe-feedback-skip]');
  const unsubscribeFeedbackSkipClick$ = fromEvent(unsubscribeFeedbackSkip, 'click');
  unsubscribeFeedbackSkipClick$.subscribe(showThankYouMessage);
}

const unsubscribeMarketingPreferences =  () => {
  const email = document.querySelector('#emailUnsubscribe');
  const payload = {
    marketingCampaigns: Array.from(
      marketingCampaignPreferences.querySelectorAll(':checked'))?.map(option => option.value),
    email: email?.value
  };

  store.dispatch(marketingCampaignPreferencesActions.fetchUnsubscribe(payload));
  sessionStorage.setItem('email', payload.email);
  sessionStorage.setItem('marketingCampaigns', JSON.stringify(payload.marketingCampaigns));
}

const unsubscribeEmailField = (email) => {
  const emailValue = email || '';
  inputEmail.setAttribute("value", emailValue);
}

const updateUpdatePreferencesButton = (disabled) => {  
  submitButton.disabled = disabled;
}

onUserLogIn$.subscribe(unsubscribeEmailField);
checkboxGroupChange$.pipe(
  mergeMap((event) => {
    updateUpdatePreferencesButton(event.length === 0);
    turnOffUnSubscribeAllInput();
    return of(event);
  })
).subscribe();
showEmailErrorMessage$.subscribe(showEmailErrorMessage);
showUnsubscribeFeedbackForm$.pipe(
  mergeMap((event) => {
    showUnsubscribeFeedbackForm();
    unsubscribeMarketingPreferences();
    return of(event);
  })
)
.subscribe();
unsubscribeAllInputChange$.pipe(
  mergeMap((event) => {
    updateUpdatePreferencesButton(!event)
    updateCheckboxStatus(event);
    return of(event);
  })
).subscribe();
feedbackItemsClick$.pipe(
  mergeMap((event) => {
    enableSubmitFeedbackButton();
    feedbackCustomOptionHandler(event);
    return of(event);
  })
).subscribe();
